var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15888 7.74747L5.006 10.0835L2.4281 10.4581L1.42552 10.6038L2.15099 11.3109L4.01639 13.1292L3.57605 15.6967L3.40479 16.6953L4.30153 16.2238L6.60726 15.0116L8.91301 16.2238L9.80975 16.6952L9.63849 15.6967L9.19812 13.1292L11.0635 11.3109L11.789 10.6037L10.7864 10.4581L8.20847 10.0834L7.05562 7.74747L6.60725 6.83896L6.15888 7.74747ZM7.12617 13.0016L6.83992 12.8511L6.60725 12.7288L6.37458 12.8511L6.08834 13.0016L6.143 12.6829L6.18743 12.4238L5.99919 12.2403L5.76762 12.0146L6.08764 11.9681L6.34776 11.9303L6.46409 11.6946L6.60724 11.4045L6.75037 11.6945L6.86671 11.9303L7.12683 11.9681L7.44688 12.0146L7.21531 12.2403L7.02707 12.4238L7.0715 12.6828L7.12617 13.0016Z",
    fill: "#264073",
    stroke: "url(#paint0_linear_58335_58103)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9401 7.74747L15.7873 10.0835L13.2093 10.4581L12.2068 10.6038L12.9322 11.3109L14.7976 13.1292L14.3573 15.6967L14.186 16.6953L15.0828 16.2238L17.3885 15.0116L19.6943 16.2238L20.591 16.6952L20.4197 15.6967L19.9794 13.1292L21.8448 11.3109L22.5702 10.6037L21.5677 10.4581L18.9897 10.0834L17.8369 7.74747L17.3885 6.83896L16.9401 7.74747ZM17.9074 13.0016L17.6212 12.8511L17.3885 12.7288L17.1558 12.8511L16.8696 13.0016L16.9242 12.6829L16.9687 12.4238L16.7804 12.2403L16.5489 12.0146L16.8689 11.9681L17.129 11.9303L17.2453 11.6946L17.3885 11.4045L17.5316 11.6945L17.648 11.9303L17.9081 11.9681L18.2281 12.0146L17.9966 12.2403L17.8083 12.4238L17.8528 12.6828L17.9074 13.0016Z",
    fill: "#264073",
    stroke: "url(#paint1_linear_58335_58103)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6276 3.99747L10.4748 6.33348L7.89685 6.70809L6.89427 6.85379L7.61974 7.56094L9.48514 9.37924L9.0448 11.9467L8.87354 12.9453L9.77028 12.4738L12.076 11.2616L14.3818 12.4738L15.2785 12.9452L15.1072 11.9467L14.6669 9.3792L16.5323 7.56091L17.2577 6.85375L16.2552 6.70806L13.6772 6.33345L12.5244 3.99747L12.076 3.08896L11.6276 3.99747ZM12.5949 9.2516L12.3087 9.10111L12.076 8.97879L11.8433 9.10111L11.5571 9.2516L11.6117 8.93288L11.6562 8.6738L11.4679 8.49031L11.2364 8.2646L11.5564 8.21809L11.8165 8.18029L11.9328 7.94458L12.076 7.65454L12.2191 7.94454L12.3355 8.18025L12.5956 8.21805L12.9156 8.26456L12.6841 8.49028L12.4958 8.67376L12.5403 8.93285L12.5949 9.2516Z",
    fill: "#264073",
    stroke: "url(#paint2_linear_58335_58103)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58335_58103",
    x1: 3.59527,
    y1: 9.33594,
    x2: 9.08641,
    y2: 15.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325272,
    stopColor: "#FBE67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535488,
    stopColor: "#FCFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769917,
    stopColor: "#F7D14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58335_58103",
    x1: 14.3765,
    y1: 9.33594,
    x2: 19.8677,
    y2: 15.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325272,
    stopColor: "#FBE67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535488,
    stopColor: "#FCFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769917,
    stopColor: "#F7D14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_58335_58103",
    x1: 9.06402,
    y1: 5.58594,
    x2: 14.5552,
    y2: 11.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325272,
    stopColor: "#FBE67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535488,
    stopColor: "#FCFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769917,
    stopColor: "#F7D14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A041"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsGroup);
export default __webpack_public_path__ + "static/media/stars_group.5529bf3fc49b832f17fadb97d1d98719.svg";
export { ForwardRef as ReactComponent };